module.exports = __webpack_public_path__ + "img/women's-world-cup-logo-colour.1d2a1445.png";